import { Record } from 'immutable';
import { actionTypes } from './tenant.actions';
import * as settings from '../settings/settings.actions';

export const TenantReducerState = Record({
  err: null,
  isFetching: false,
  currentTenant: null
});

export const TenantState = Record({
  id: null,
  name: null,
  logoUrl: null,
  slug: null,
  absoluteUrl: null,
  featureList: [],
});

export const tenantReducer = (state = new TenantReducerState(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_CURRENT_TENANT_BEGIN:
      return state.set('isFetching', true)
                  .set('currentTenant', null)
                  .set('err', null);
    case actionTypes.FETCH_CURRENT_TENANT_SUCCESS:
       return state.set('isFetching', false)
                   .set('currentTenant', new TenantState(action.data))
                    .set('err', null);
    case actionTypes.FETCH_CURRENT_TENANT_FAILURE:
       return state.set('isFetching', false)
                   .set('err', action.err);
    case settings.actionTypes.SAVE_NEW_LOGO_BEGIN:
      return state.setIn(['currentTenant', 'logoUrl'], null);
    case settings.actionTypes.SAVE_NEW_LOGO_FAILURE:
      return state.setIn(['currentTenant', 'logoUrl'], action.currentLogoUrl);
    case settings.actionTypes.SAVE_NEW_LOGO_SUCCESS:
      return state.setIn(['currentTenant', 'logoUrl'], action.data.logoUrl);
    default:
      return state;
  }
}
